import axios from "axios";

const uninterceptedAxiosInstance = axios.create();

export function uploadPresigned(url, data, newHeader) {
  return uninterceptedAxiosInstance.put(url, data, {
    headers: newHeader,
  });
}
